import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"
import { API_UPDATE_DEFAULT_BANK_REQUESTS_URL } from "../constants"
import { RootState } from "../../store/store"
import { ICreateUpdateDefaultBankRequestRequest, ICreateUpdateDefaultBankRequestResponse } from "../interface"
import { axios } from "../axios"

async function create(token: string | null, req: ICreateUpdateDefaultBankRequestRequest) {
  const response = await axios(API_UPDATE_DEFAULT_BANK_REQUESTS_URL, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    data: req
  })
  // TODO: обработка ошибок
  return response.data
}

export const useCreateUpdateDefaultBankRequest = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<ICreateUpdateDefaultBankRequestResponse, void, ICreateUpdateDefaultBankRequestRequest>({
    mutationFn: (req) => create(token, req),
    retry: false,
  })
}
